<template>
<!-- 售后管理 -->
  <section>
    <!-- 搜索/查询 -->
    <el-col :span="24" class="order_toolbar toolbar pad_left">
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <p style="margin: 0;margin-left: -22px;" class="goodslist1">
            <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
          </p>
          <div style="position: absolute;right:-19px;top:-10px" class="sanjiao"></div>
        </div>
        <el-collapse-transition>
          <div style="padding:0px 12px" v-show="show3">
            <el-form :inline="true" :model="filters" style="margin-top:10px;display:flex;" class="findform">
              <!-- 顶部搜索框 -->
              <el-form-item style="display:flex;width:100%" label="关键词语：">
                <el-input v-model="filters.searchKey" placeholder="商品名称/售后号/订单号/手机号"></el-input>
              </el-form-item>
              <el-form-item style="display:flex;width:100%;margin-left:10px;" label="售后类型/状态：">
                <el-cascader placeholder="请选择" v-model="typeStatus" :options="optionsType"
                  style="width:100%" filterable clearable @change="handleChangeType"/>
              </el-form-item>
              <el-form-item style="display:flex;width:100%;margin-left:30px;" label="所属品牌商：">
                <el-cascader placeholder="请选择" v-model="cityBrand" :options="optionsBrand"
                  style="width:100%" filterable clearable @change="handleChange"/>
              </el-form-item>
            </el-form>
            <el-form class="findform" style="display:flex;position: relative;">
              <el-form-item style="display:flex;width:31.6%;" label="提交时间：">
                <el-date-picker
                  :title="value6"
                  v-model="value6"
                  :editable="iseditable"
                  style="width:100%;cursor:pointer;background:#fff;border:1px solid #eee;"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  @change="changetime"
                  end-placeholder="结束日期"/>
              </el-form-item>
              <el-form-item style="position: absolute;right: 0;top: 0;">
                <el-button type="danger" @click="onSubmit">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
    </el-col>

    <!--列表-->
    <template>
      <el-col :span="24" class="order_content main_container">
        <section class="model_section">
          <el-col :span="18" style>
            <p class="model_top_title">售后管理</p>
          </el-col>
        </section>
        <!-- table 列表 -->
        <div class="table_container">
          <div class="table_inner_container" style="height:auto">
            <el-table :data="dataList" class="invoice_tab" stripe border style="height:auto;max-height:500px">
              <el-table-column label="售后单号" align="center" width="170">
                <template scope="scope">
                  <span :title="scope.row.AsOrderNo" :label="scope.row.AsOrderNo"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.AsOrderNo}}</span>
                </template>
              </el-table-column>
              <el-table-column label="订单号" align="center" width="170">
                <template scope="scope">
                  <span :title="scope.row.OrderNo" :label="scope.row.OrderNo"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.OrderNo}}</span>
                </template>
              </el-table-column>
              <el-table-column label="售后类型" align="center" width="170">
                <template scope="scope">
                  <span :title="scope.row.TypeName" :label="scope.row.TypeName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.TypeName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" align="center" width="170">
                <template scope="scope">
                  <span :title="scope.row.StatusName" :label="scope.row.StatusName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.StatusName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="商品名称" align="center">
                <template scope="scope">
                  <span :title="scope.row.GoodsName" :label="scope.row.GoodsName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.GoodsName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="售后原因" align="center">
                <template scope="scope">
                  <span :title="scope.row.Remark" :label="scope.row.Remark"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.Remark}}</span>
                </template>
              </el-table-column>
              <el-table-column label="提交时间" align="center">
                <template scope="scope">
                  <span :title="scope.row.SubmitTime" :label="scope.row.SubmitTime"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.SubmitTime}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" width="100" align="center">
                <template scope="scope">
                  <span @click="seeOrder(scope.row.Id,scope.row.TypeName)" class="action_container">
                    <i class="el-icon-view"></i>查看
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--分页-->
          <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
            <el-pagination
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :current-page="pageIndex"
              :page-size="10"
              :total="total"/>
          </el-col>
        </div>
      </el-col>
    </template>
  </section>
</template>
<script>
import { getSelectAfterSaleTypeAndStatus, SelectBBListByCondition, GetAfterSaleList } from "../../api/api";

export default {
  name: 'refund',
  props: ["menuAction"],
  data() {
    return {
      show3:false,
      value6: "",
      iseditable: false,
      activeoptions: [], // 售后类型
      statusoptions: [], // 售后状态
      dataList: [], // 查询列表
      optionsindex: "",
      optionsType: [],
      optionsBrand: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      filters: {
        searchKey: "", // 检索关键字
        afterSaleType: "", // 售后类型
        afterSaleStatus: "", // 售后状态
        cityId: "",
        brandBusinessId: "", // 品牌商
        btime: "", // 开始时间
        etime: "" //结束时间
      },
      typeStatus: [], // 售后类型/状态
      cityBrand: [] // 所属品牌商
    }
  },
  methods: {
    //查询列表
    getorder() {
      let that = this;
      let addParams = {
        // staffId: 26, // 当前操作人id
        staffId: localStorage.Id, // 当前操作人id
        searchKey: that.filters.searchKey, // 检索关键字
        afterSaleType: that.filters.afterSaleType, // 检索区域类型id
        afterSaleStatus: that.filters.afterSaleStatus, // 检索区域状态id
        btime: that.filters.btime, // 检索区域 开始时间
        etime: that.filters.etime, // 检索区域 结束时间
        cityId: that.filters.cityId,
        brandBusinessId: that.filters.brandBusinessId, // 检索区域品牌商id
        index: that.pageIndex,// 分页数据 当前页码
        size: that.pageSize // 分页数据 每页显示条数
      };
      GetAfterSaleList(addParams).then(data => {
          this.dataList = data.ResultObj;
          this.total = data.RowsCount;
        })
        .catch(err => {
          this.dataList = [];
        });
    },
    // 查看
    seeOrder(id, typeName) {
      if(typeName == "退款") {
        this.$router.push({
          path:"/serviceRefund",
          query: {
            Id: id
          }
        })
      }
      if(typeName == "换货") {
        this.$router.push({
          path:"/serviceExchange",
          query: {
            Id: id
          }
        })
      }
      if(typeName == "维修") {
        this.$router.push({
          path:"/serviceRepair",
          query: {
            Id: id
          }
        })
      }
    },
    // 提交时间
    changetime() {
         if(this.value6+""=="null"){
           this.value6 = ["",""]
      }
      this.filters.btime = this.value6[0];
      this.filters.etime = this.value6[1];
    },
    // 重置
    fnReset() {
      this.filters = {
        searchKey: "", // 检索关键字
        afterSaleType: "", // 售后类型
        afterSaleStatus: "", // 售后状态
        cityId: "",
        brandBusinessId: "", // 品牌商
        btime: "", // 开始时间
        etime: "" //结束时间
      },
      this.value6 = '';
      this.typeStatus = []; // 售后类型/状态
      this.cityBrand = []; // 所属品牌商
      // this.pageIndex = 1;
      // this.getorder();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getorder();
    },
    // 所属品牌商
    handleChange(val) {
      this.filters.cityId = val[0];
      this.filters.brandBusinessId = val[1];
    },
    //获取城市下的品牌商
    getBrandByCityId() {
      let obj = {
        userId: localStorage.Id
      };
      SelectBBListByCondition(obj).then(data => {
        let that = this
        let brandBusinessList = [{value: 0,label: "全部"}];
        data.ResultObj.map(item => {
          if(item.BbModel.length > 0) {
            let cityData = {value:item.CityId,label:item.CityName,children:[{ value:0, label:"全部"}]}
            brandBusinessList.push(cityData)
            item.BbModel.map(mendian => {
              cityData.children.push({value:mendian.Id, label:mendian.Name})
            })
          }
        });
        that.optionsBrand = brandBusinessList
      });
    },
    // 售后类型/状态
    handleChangeType(val) {
      this.filters.afterSaleType = val[0];
      this.filters.afterSaleStatus = val[1];
    },
    // 获取售后类型 + 售后状态
    getactivitykind() {
      let addParams = {
        userId: localStorage.Id
      };
      getSelectAfterSaleTypeAndStatus(addParams).then(data => {
        let that = this;
        let typeSalesList = [{value: 0,label: "全部"}];
        data.ResultObj.map(item => {
          let cityData = {value:item.Typeid,label:item.TypeName,children:[{ value:0, label:"全部"}]}
          typeSalesList.push(cityData)
          item.StatusList.map(itemState => {
            cityData.children.push({value:itemState.StatusId, label:itemState.StatusName})
          })
        });
        that.optionsType = typeSalesList
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getorder();
    }
  },
  created() {
    let that = this;
    // 获取售后类型
    this.getactivitykind();
    // 获取所属品牌商
    this.getBrandByCityId();
    // 查询列表
    setTimeout(function() {
      that.getorder();
    }, 200);
  },
  watch: {
    menuAction: function(val) {
      this.menuAction = val;
    }
  },
  // 缓存数据
  beforeRouteEnter(to, from, next) {
    let arrPath = [
      '/serviceRefund',
      '/serviceExchange',
      '/serviceRepair'
    ]
    if(arrPath.indexOf(from.path) >= 0){
      to.meta.init = false;
    } else {
      to.meta.init = true
    }
    next()
  },
  activated() {
    if(this.$route.meta.init){
      // 初始化处理
      this.filters = {
        searchKey: "", // 检索关键字
        afterSaleStatus: "", // 售后状态
        afterSaleType: "", // 售后类型
        cityId: "",
        brandBusinessId: "", // 品牌商
        btime: "", // 开始时间
        etime: "" //结束时间
      }
      this.typeStatus = [] // 初始化售后类型/状态
      this.cityBrand = [] // 初始化所属品牌商
      this.value6 = "" // 初始化提交时间
      this.total = 1
      this.pageIndex = 1
      this.getorder();
    }
  }
}
</script>
<style scoped>
/* 表格操作 */
.action_container {
  color: #677c9d;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// refund.vue?64d14e31